import dAuth from "./dAuth.js";

export default (auth, org) => dAuth(auth, org);
